/**
 * Glyphs for the Arrange sub-tool buttons (issue #115), read from
 * `src/icons/arrange-*.svg` through the shared {@link stripIconSvg} (#216).
 *
 * They stay runtime constants rather than `<!-- svg:… -->` markers because the
 * arrange bar's buttons are built with `document.createElement` from
 * `ARRANGE_GROUPS` — there is no markup to carry a marker. What the ticket
 * buys here is the other half: one file per glyph, normalised by the same
 * function the static path uses, so an arrange bar icon and a toolbar icon
 * cannot come out differently.
 *
 * The bars were `<rect>`s built by a string helper. They are paths now, and
 * they had to become paths: the normaliser strips `width` / `height`
 * attributes globally, so a rect drawn the obvious way loses its dimensions
 * and renders nothing — silently, in both the build and the type checker.
 */
import alignBottomRaw from "./arrange-align-bottom.svg?raw";
import alignLeftRaw from "./arrange-align-left.svg?raw";
import alignRightRaw from "./arrange-align-right.svg?raw";
import alignTopRaw from "./arrange-align-top.svg?raw";
import centerHorizontalRaw from "./arrange-center-horizontal.svg?raw";
import centerVerticalRaw from "./arrange-center-vertical.svg?raw";
import distributeHorizontalRaw from "./arrange-distribute-horizontal.svg?raw";
import distributeVerticalRaw from "./arrange-distribute-vertical.svg?raw";
import { stripIconSvg } from "./stripIconSvg";

export const ARRANGE_ALIGN_LEFT_ICON = stripIconSvg(alignLeftRaw);
export const ARRANGE_ALIGN_RIGHT_ICON = stripIconSvg(alignRightRaw);
export const ARRANGE_ALIGN_TOP_ICON = stripIconSvg(alignTopRaw);
export const ARRANGE_ALIGN_BOTTOM_ICON = stripIconSvg(alignBottomRaw);
export const ARRANGE_CENTER_HORIZONTAL_ICON = stripIconSvg(centerHorizontalRaw);
export const ARRANGE_CENTER_VERTICAL_ICON = stripIconSvg(centerVerticalRaw);
export const ARRANGE_DISTRIBUTE_HORIZONTAL_ICON = stripIconSvg(
  distributeHorizontalRaw,
);
export const ARRANGE_DISTRIBUTE_VERTICAL_ICON = stripIconSvg(
  distributeVerticalRaw,
);
